/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../page-layout/page-layout.component.ngfactory';
import * as i2 from '../../../../../app/components/widgets/page-layout/page-layout.component';
import * as i3 from '../../../../../app/services/auth-controller/auth-controller.service';
import * as i4 from '../../../../../app/components/services/rest/auth-rest.service';
import * as i5 from '@angular/router';
import * as i6 from 'ngx-toastr';
import * as i7 from 'ng2-translate/src/translate.service';
import * as i8 from '../panel/panel.component.ngfactory';
import * as i9 from '../../../../../app/components/widgets/panel/panel.component';
import * as i10 from '@angular/common';
import * as i11 from '../../../../../app/components/widgets/large-page-layout/large-page-layout.component';
const styles_LargePageLayoutWidget:any[] = ([] as any[]);
export const RenderType_LargePageLayoutWidget:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_LargePageLayoutWidget,data:{}});
export function View_LargePageLayoutWidget_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),8,'page-layout',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_PageLayoutWidget_0,
      i1.RenderType_PageLayoutWidget)),i0.ɵdid(1,245760,(null as any),0,i2.PageLayoutWidget,
      [i3.AuthControllerService,i4.AuthRESTService,i5.Router,i6.ToastrService,i7.TranslateService],
      (null as any),(null as any)),(_l()(),i0.ɵted(-1,0,['\n    '])),(_l()(),i0.ɵeld(3,
      0,(null as any),0,4,'panel',([] as any[]),(null as any),(null as any),(null as any),
      i8.View_PanelWidget_0,i8.RenderType_PanelWidget)),i0.ɵdid(4,49152,(null as any),
      0,i9.PanelWidget,[i10.Location,i5.Router],{title:[0,'title'],icon:[1,'icon'],
          showGoBack:[2,'showGoBack'],goBackLink:[3,'goBackLink']},(null as any)),
      (_l()(),i0.ɵted(-1,0,['\n        '])),i0.ɵncd(0,0),(_l()(),i0.ɵted(-1,0,['\n    '])),
      (_l()(),i0.ɵted(-1,0,['\n']))],(_ck,_v) => {
    var _co:i11.LargePageLayoutWidget = _v.component;
    _ck(_v,1,0);
    const currVal_0:any = _co.title;
    const currVal_1:any = _co.icon;
    const currVal_2:any = true;
    const currVal_3:any = _co.goBackLink;
    _ck(_v,4,0,currVal_0,currVal_1,currVal_2,currVal_3);
  },(null as any));
}
export function View_LargePageLayoutWidget_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'large-page-layout',
      ([] as any[]),(null as any),(null as any),(null as any),View_LargePageLayoutWidget_0,
      RenderType_LargePageLayoutWidget)),i0.ɵdid(1,49152,(null as any),0,i11.LargePageLayoutWidget,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const LargePageLayoutWidgetNgFactory:i0.ComponentFactory<i11.LargePageLayoutWidget> = i0.ɵccf('large-page-layout',
    i11.LargePageLayoutWidget,View_LargePageLayoutWidget_Host_0,{title:'title',goBackLink:'goBackLink',
        icon:'icon'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2xhcmdlLXBhZ2UtbGF5b3V0L2xhcmdlLXBhZ2UtbGF5b3V0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvd2lkZ2V0cy9sYXJnZS1wYWdlLWxheW91dC9sYXJnZS1wYWdlLWxheW91dC5jb21wb25lbnQudHMiLCJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvd2lkZ2V0cy9sYXJnZS1wYWdlLWxheW91dC9sYXJnZS1wYWdlLWxheW91dC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2xhcmdlLXBhZ2UtbGF5b3V0L2xhcmdlLXBhZ2UtbGF5b3V0LmNvbXBvbmVudC50cy5MYXJnZVBhZ2VMYXlvdXRXaWRnZXRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8cGFnZS1sYXlvdXQ+XG4gICAgPHBhbmVsIFtzaG93R29CYWNrXT1cInRydWVcIiBbdGl0bGVdPVwidGl0bGVcIiBbaWNvbl09XCJpY29uXCIgW2dvQmFja0xpbmtdPVwiZ29CYWNrTGlua1wiPlxuICAgICAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgPC9wYW5lbD5cbjwvcGFnZS1sYXlvdXQ+IiwiPGxhcmdlLXBhZ2UtbGF5b3V0PjwvbGFyZ2UtcGFnZS1sYXlvdXQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7b0NBQUEsVUFBQTtNQUFBO01BQUEsNkJBQWEsa0NBQ1Q7TUFBQTtxREFBQSxVQUFBO01BQUE7VUFBQTtNQUFtRiw2Q0FDL0UsTUFBeUI7TUFDckI7O0lBSFo7SUFDK0I7SUFBZ0I7SUFBcEM7SUFBa0Q7SUFBekQsV0FBMkIsVUFBZ0IsVUFBcEMsVUFBa0QsU0FBekQ7Ozs7b0JDREo7TUFBQTtzQ0FBQSxVQUFBO01BQUE7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/large-page-layout/large-page-layout.component.ngfactory.ts